export const trackingEvents = {
  dashboard: {
    visited_single_project: "Visited Dashboard (Single Project)",
    visited_all_projects: "Visited Dashboard (All Projects)",
    visited_rollups: "Visited Dashboard (Rollups Mode)",
    archived_project_all_projects:
      "Archived Project from Dashboard (All Projects)",
    archived_project_single_project:
      "Archived Project from Dashboard (Single Project)",
    archived_project_rollups: "Archived Project from Dashboard (Rollups Mode)",
    deleted_project_all_projects:
      "Deleted Project from Dashboard (All Projects)",
    deleted_project_single_project:
      "Deleted Project from Dashboard (Single Project)",
    deleted_project_rollups: "Deleted Project from Dashboard (Rollups Mode)",
    completed_todo: "Marked To Do as Completed on Dashboard",
    switched_to_experiments_by_lead:
      "Switched to Experiment Lead tab on Dashboard",
    switched_to_experiments_by_stage:
      "Switched to Experiments Stage Lead on Dashboard",
    clicked_help_guide: "Clicked on Dashboard Help Guide"
  },
  account_settings: {
    visited: "Visited Account Settings"
  },
  super_admins: {
    visited_super_admins: "Visited Super Admins Page",
    added_super_admin: "Added New Super Admin",
    removed_super_admin: "Removed Super Admin"
  },
  account_details: {
    visited: "Visited Account Details Page",
    updated: "Updated Account Details"
  },
  help_guide: {
    teams: {
      new: "Visited Creating New Team from Help Guide",
      edit: "Visited Editing Team from Help Guide",
      delete: "Visited Deleting Team from Help Guide",
      copy: "Visited Copy Users to Team from Help Guide",
      move: "Visited Move Users to Team from Help Guide",
      comment: "Visited Tagging Teams in Comments from Help Guide",
      notification:
        "Visited Setting Custom Notifications for Teams from Help Guide"
    }
  },
  project_grouping: {
    visited_page: "Visited Project Grouping Page",
    created_project: "Created New Project",
    edited_project: "Edited Single Project",
    moved_single_project: "Moved Single Project to Group",
    archived_single_project: "Archived Single Project",
    unarchived_single_project: "Unarchived Single Project",
    deleted_single_project: "Deleted Single Project",
    created_group: "Created New Group",
    renamed_group: "Renamed Group",
    moved_group_to_collection: "Moved Group to Collection",
    deleted_group: "Deleted Group",
    created_collection: "Created New Collection",
    renamed_collection: "Renamed Collection",
    deleted_collection: "Deleted Collection",
    selected_multiple_projects: "Selected Multiple Projects",
    archived_multiple_projects: "Archived Multiple Projects",
    unarchived_multiple_projects: "Unarchived Multiple Projects",
    moved_multiple_projects: "Moved Multiple Projects to Group",
    deleted_multiple_projects: "Deleted Multiple Projects",
    filtered: "Filtered Projects by Archived",
    clicked_help_guide: "Clicked on Help Guide"
  },
  watchtower: {
    clicked_contact_support: "Clicked on Contact Support to Unlock Watchtower",
    added_module: "Activated Watchtower Module",
    removed_module: "Deactivated Watchtower Module",
    clicked_module_learn_more: "Clicked on Learn More About Watchtower",
    clicked_tutorial_overiew_tab:
      "Switched to Watchtower Help Videos Overview Tab",
    clicked_tutorial_instance_tab:
      "Switched to Watchtower Help Videos Instance Management Tab",
    clicked_tutorial_pages_tab:
      "Switched to Watchtower Help Videos Page & URL Mapping Tab",
    clicked_help_guide: "Clicked on Watchtower Help Guide",
    clicked_on_download_externsion: "Clicked on Download Watchtower Extension",
    created_instance: "Created New Watchtower Instance",
    deleted_instance: "Deleted Watchtower Instance",
    updated_instance: "Updated Watchtower Instance"
  },
  clicked_customise_banner: "Clicked on Customise Now Contextual Banner",
  ai: {
    hypothesis_evaluation: "AI - Evaluated Hypothesis",
    applied_improved_hypothesis: "AI - Applied Improved Hypothesis",
    generated_insights_from_experiment:
      "AI - Generated Insights from Experiment",
    generated_insight_from_insights: "AI - Generated Insight from Insights",
    insights_ai_search: "AI - Used Insights AI Search",
    observations_ai_search: "AI - Used Observations AI Search",
    generated_observations_from_research:
      "AI - Generated Observations from Research",
    synthesized_brainstorm_idea: "AI - Synthesized Brainstorm Idea",
    opened_mosaic_chat: "AI - Opened Mosaic Chat",
    opened_brainstorm_synthesis_chat: "AI - Opened Brainstorm Synthesis Chat"
  }
} as const;
